document.addEventListener('DOMContentLoaded', function () {

  // Run ONLY on custom-wmn products
  const sizeWidget = document.querySelector('.cmn-size-widget');
  if (!sizeWidget) return;

  const widthInput = document.getElementById('cmn-width');
  const heightInput = document.getElementById('cmn-height');
  const errorBox = sizeWidget.querySelector('.cmn-size-error');
  const form = document.querySelector('form[action="/cart/add"]');

  if (!widthInput || !heightInput || !form) return;

  function enforceThreeDigits(input) {
    if (!input.value) return;

    // Remove non-numbers
    input.value = input.value.replace(/\D/g, '');

    // Trim to max 3 digits
    if (input.value.length > 3) {
      input.value = input.value.slice(0, 3);
    }
  }

  widthInput.addEventListener('input', () => enforceThreeDigits(widthInput));
  heightInput.addEventListener('input', () => enforceThreeDigits(heightInput));

  // Final hard stop on submit
  form.addEventListener('submit', function (e) {
    const w = widthInput.value;
    const h = heightInput.value;

    if (w.length > 3 || h.length > 3) {
      e.preventDefault();
      errorBox.textContent = 'Width and Height must be 3 digits or less (max 999 cm).';
      errorBox.hidden = false;
      return false;
    }

    errorBox.hidden = true;
  });

});
